<template>
  <LinksCss
    :links="[
      getWithHost(swiperCss),
      getWithHost(pagination),
      getWithHost(navigation),
      getWithHost(virtual),
      getWithHost(style)
    ]"
    v-model:on-load-end="show"
  />
  <div v-if="show" ref="rootEl" class="select-none">
    <div>
      <swiper
        :class="{ ['swiper-custom-locked']: swipeInstanceRef?.value.isLocked }"
        @slides-updated="swipeInstanceKey++"
        :modules="modules"
        :navigation="{
          nextEl: '.swiper-button-custom-next',
          prevEl: '.swiper-button-custom-prev'
        }"
        :slidesPerView="countElement"
      >
        <swiper-slide v-for="(item, index) in props.props.items" :key="index" :virtualIndex="index">
          <a
            :href="item.page_url"
            class="group flex flex-col justify-center items-center hover:text-red-600"
          >
            <div class="w-[159px] min-w-[159px] flex justify-center">
              <img class="filter-carousel group-hover:filter-red" style="height: 60px; object-fit: contain; " :src="item.image"  />
            </div>
            <div class="text-lg font-semibold">
              {{ item.name }}
            </div>
          </a>
        </swiper-slide>
        <SwipeInstance ref="swipeInstanceRef" :key="swipeInstanceKey"> </SwipeInstance>
      </swiper>
    </div>
  </div>
</template>
<script lang="ts" setup>
import SwipeInstance from '@/components/SwipeInstance.vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Pagination, Navigation, Virtual } from 'swiper/modules'
import swiperCss from 'swiper/css?url'
import pagination from 'swiper/css/pagination?url'
import navigation from 'swiper/css/navigation?url'
import virtual from 'swiper/css/virtual?url'
import style from '@/styles/book_carousel.css?url'
import { getWithHost } from '@/utils/utils'
import { type CategoryCarouselProps } from '@/types/book_item'
import { computed, ref, watch } from 'vue'
import { useElementSize } from '@vueuse/core'
import LinksCss from '@/components/LinksCss.vue'

const rootEl = ref(null)
const { width } = useElementSize(rootEl)
const modules = [Pagination, Navigation, Virtual]
const show = ref(false)

const props = defineProps<{ props: CategoryCarouselProps; loading?: boolean }>()
const countElement = computed(() => {
  return Math.floor(width.value / 159)
})

const swipeInstanceKey = ref(0)
const swipeInstanceRef = ref<InstanceType<typeof SwipeInstance> | null>(null)

watch(swipeInstanceRef,(newv) => {
  if(!newv) {
    return
  }
  if (swipeInstanceKey.value > 3) {
    return
  }
  newv.value.slideTo(0)
})
 
</script>
